import { useState } from "react";

export default function Welcome({ onStart }) {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");

  function handleStart() {
    const trimmedFirstName = firstName.trim();
    const trimmedLastName = lastName.trim();
    const trimmedEmail = email.trim();

    if (!trimmedFirstName || !trimmedLastName || !trimmedEmail) {
      setError("Please enter your first name, last name, and email address.");
      return;
    }

    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(trimmedEmail)) {
      setError("Please enter a valid email address.");
      return;
    }

    setError("");
    onStart({
      firstName: trimmedFirstName,
      lastName: trimmedLastName,
      email: trimmedEmail,
    });
  }

  return (
    <div className="welcome">
      <div className="welcome-left">
        <p className="section-label welcome-label">Flow Identity Assessment</p>
        <h1>
          Whatever you've been noticing —<br />
          <em>this is where you look at it.</em>
        </h1>
        <p className="welcome-lead">
          Ten short scenarios from real life. No right answers, no scores to
          beat — just honest recognition of how you actually meet these moments.
          It takes about ten minutes, and it meets you exactly where you are.
        </p>
        <div className="welcome-deliverables">
          <h3>What you'll receive</h3>
          <div className="deliverable">
            <span className="d-check">✓</span>
            <span>
              A <strong>reflection</strong> of where you seem to be right now
            </span>
          </div>
          <div className="deliverable">
            <span className="d-check">✓</span>
            <span>
              The <strong>question</strong> you seem to be carrying
            </span>
          </div>
          <div className="deliverable">
            <span className="d-check">✓</span>
            <span>
              A <strong>personalized</strong> next step
            </span>
          </div>
          <div className="deliverable">
            <span className="d-check">✓</span>
            <span>
              <em>
                Plus, <strong>a free gift</strong>
              </em>
            </span>
          </div>
        </div>
        <div className="form-row">
          <div className="form-field">
            <label>First name</label>
            <input
              type="text"
              value={firstName}
              onChange={(e) => {
                setFirstName(e.target.value);
                setError("");
              }}
              required
            />
          </div>
          <div className="form-field">
            <label>Last name</label>
            <input
              type="text"
              value={lastName}
              onChange={(e) => {
                setLastName(e.target.value);
                setError("");
              }}
              required
            />
          </div>
        </div>
        <div className="form-field">
          <label>Email address</label>
          <input
            type="email"
            value={email}
            onChange={(e) => {
              setEmail(e.target.value);
              setError("");
            }}
            required
          />
        </div>

        {error && <p className="form-error">{error}</p>}

        <button className="btn-start" onClick={handleStart}>
          Begin →
        </button>
        <p className="btn-start-sub">
          Free · 10 minutes · Your results are private
        </p>
      </div>
      <div className="welcome-right">
        <p className="wr-quote">
          "There are no right or wrong answers here. Only honest ones — and the
          honest ones are the only ones that can help you."
        </p>
        <div className="wr-how">
          <p>
            Each scenario describes a moment you've probably lived. Choose the
            response closest to what you actually do — not what you'd like to
            do, or think you should do.
          </p>
          <p>
            Your result isn't a personality type. It's a reflection of where you
            are right now — and where you are can change.
          </p>
        </div>
        <p className="welcome-data-note">
          Your responses are used only to generate your personal reflection. We
          don't sell or share your data.
        </p>
      </div>
    </div>
  );
}
